<template>
  <div class="title">
    {{ title }}
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Title',
  props: ['title']
})
export default class TitleComponent extends Vue {}
</script>

<style lang="scss" scoped>
.title {
  font-size: $eighteenSize;
  line-height: $fourteenSize;
  font-weight: 500;
  font-family: 'Ubuntu-Medium';
  color: $main-text;
}
</style>
